import axios from 'axios';
import GraniteError from 'granite-admin/utils/granite-error';
import { getAuthToken, getOrganisation } from 'granite-admin/utils/auth-singleton';
import { removeAuthToken } from 'granite-admin/accounts/controllers/sidebar';
import { env } from 'granite-admin/env';

/**
 * NOTES:-
 *  - API client return axios instance.
 *  - we can call axios methods on this instance.
 *  - additional standard headers & configs can be passed
 *    to create this instance.
 */
export default ((url, headers, config) => {
  let defaultHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };
  const authToken = getAuthToken();
  const organisationId = getOrganisation();
  if (authToken) {
    defaultHeaders['Authorization'] = `Bearer ${authToken}`;
  }
  if (organisationId && organisationId !== 'undefined') {
    defaultHeaders['organisation'] = organisationId;
  }
  // TODO :- in case of timeout, use interceptor to throw error format - its crashing
  // TODO :- request cancellation support on unmount
  if (!authToken) {
    defaultHeaders['Client'] = env.REACT_APP_CLIENT_ID || process.env.REACT_APP_CLIENT_ID;
  }
  let defaultConfig = {
    timeout: 60000
  };
  if (headers) {
    defaultHeaders = {
      ...defaultHeaders,
      ...headers
    };
  }
  if (config) {
    defaultConfig = {
      ...defaultConfig,
      ...config
    };
  }
  const axiosInstance = axios.create({
    baseURL: url ? url : env.REACT_APP_GRANITE_BASE_URL || process.env.REACT_APP_GRANITE_BASE_URL,
    headers: defaultHeaders,
    ...defaultConfig
  });
  axiosInstance.interceptors.request.use(function (config) {
    if (window.NProgress) window.NProgress.start();
    return config;
  });
  axiosInstance.interceptors.response.use(response => {
    if (window.NProgress) window.NProgress.done();
    return Promise.resolve(response);
  }, err => {
    if (window.NProgress) window.NProgress.done();
    console.log({
      code: err.code,
      response: err.response
    });
    if (!err.response && !err.code) {
      throw new GraniteError('Network Error', true);
    }
    if (err.code === 'ERR_CANCELED') {
      throw new GraniteError('Action Aborted', true);
    }
    if (err.code === 'ECONNABORTED') {
      throw new GraniteError('Timeout Occured', true);
    }
    let data = err.response?.data;
    if (err.response && err.response.status === 401) {
      //clear all the tokens
      removeAuthToken();
      window.location.href = '/login';
    }
    if (!data.status) {
      throw new GraniteError({
        api_error: err.response.status + ', Something went wrong'
      }, true);
    } else if (data.status === 'multi_field_error') {
      let message = {};
      data.message.forEach(item => {
        message[item.code] = item.message;
      });
      throw new GraniteError(message, true);
    }
    if (err.response && err.response.status === 422) {
      throw new GraniteError(data, true);
    } else {
      throw new GraniteError({
        field_error: data.invalid_params,
        title: data.title,
        status: data.status
      }, true);
    }
    /*if (data.code) {
      throw new GraniteError({field_error: data.message}, true);
    } else {
      throw new GraniteError({api_error: err.response.status + ', Something went wrong'}, true);
    }*/
    // throw new GraniteError(data, true);
  });

  return axiosInstance;
});